export const addDocumentRevisionReason = ({ form }) => {
    form.setConfig({
        "title": "Add Document Revision Reason",
        "type": "push",
        "location": "Database/DocumentRevisionTypes",
        "fields": [{
            "label": "Reason",
            "name": "Name"
        }]
    });
    form.toggle();
}

export const editDocumentRevisionReason = ({ form, rowItem }) => {
    form.setValues({
        "Name": rowItem.Name
    });
    form.setConfig({
        "title": "Edit Document Revision Reason",
        "type": "update",
        "location": `Database/DocumentRevisionTypes/${rowItem.ID}`,
        "fields": [{
            "label": "Reason",
            "name": "Name",
            "type": "text"
        }]
    });
    form.toggle();
}
